// import { createConnection } from 'typeorm';
// import { M_SIPARIS_DETAY } from './../../models/M_SIPARIS_DETAY';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { IndexedDBWrapper } from '../indexeddb-wrapper';
// import { SQLitePorter } from '@ionic-native/sqlite-porter';






@Injectable()
export class DalProvider {

  static connection: any;
  private indexedDBWrapper: IndexedDBWrapper;
  
  constructor() {
    this.indexedDBWrapper = new IndexedDBWrapper();
  }

  createAndGetConnection(options: any) {
    return new Promise((res, err) => {

      // IndexedDB kullanımı - WebSQL tamamen kaldırıldı
      this.indexedDBWrapper.openDatabase(options.database, "", options.description, 25 * 1024 * 1024)
        .then((dbWrapper) => {
          DalProvider.connection = dbWrapper;
          console.log('DalProvider connection set:', dbWrapper);
          // Veritabanı bağlantısının tam olarak kurulduğundan emin ol
          if (dbWrapper.db) {
            console.log('Database connection confirmed, creating tables...');
            dbWrapper.transaction(function (tx) {
              DalProvider.createDatabase(tx);
              res(dbWrapper)
            });
          } else {
            console.error('Database connection not established');
            err(new Error('Database connection not established'));
          }
        })
        .catch((error) => {
          console.error('IndexedDB bağlantı hatası:', error);
          err(error);
        });
    })

  }


  static createDatabase(tx) {
 

    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Siparis" +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "StokKodu text," +
      "StokAdi text,"+
      "Barcode1 text," +
      "AlisFiyat double,"+
      "SiparisTarihi text,"+
      "Miktar double,"+
      "Birim text,"+
      "CariKodu text,"+
      "CariAdi text,"+
      "IslemTuru double,"+
      "GelisTarihi string,"+
      "AktarimDurumu double,"+
      "IslemTarihi text,"+
      "IslemYapanPersonel text,"+
      "SIPARIS_DURUM_ID double,"+
      "siparisID double,"+
      "Tutar double,"+
      "Kdv double,"+
      "BirimKodu,"+
      "VadeGun double,"+
      "ACIK1 string,"+  
      "ACIK2 string,"+ 
      "ACIK3 string,"+   
      "ACIK4 string,"+  
      "ACIK5 string,"+  
      "ACIK6 string,"+  
      "OZELKOD string,"+
      "FabrikaMaliyet double"+  

  
      ")");
    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS M_SIPARIS_DETAY " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "StokKartID double,"+
      "IslemTuru double,"+
      "FaturaID double,"+
      "SatirNo double,"+
      "CariKartID double,"+
      "DepoKodu double,"+
      "Miktar double,"+
      "BirimFiyat double,"+
      "IskontoOran1 double,"+
      "IskontoOran2 double,"+
      "IskontoOran3 double,"+
      "IskontoTutar double,"+
      "IskontoluBirimFiyati double,"+
      "AraTutar double,"+
      "Kdv double,"+
      "Tutar double,"+
      "KdvOran double,"+
      "SlsMan double,"+
      "Sign double,"+
      "SaticiRef double,"+
      "Maliyet double,"+
      "NetFiyat double,"+
      "siparisID double,"+
      "UrunName text,"+
      "ItemsRef double,"+
      "VadeGun double,"+
      "SIPARIS_DURUM_ID double,"+
      "ACIK1 string,"+  
      "ACIK2 string,"+ 
      "ACIK3 string,"+   
      "ACIK4 string,"+  
      "ACIK5 string,"+  
      "ACIK6 string"+  
       ")");




    tx.executeSql(
      "CREATE TABLE IF NOT EXISTS NL_Servis " +
      "(" +
      "ID INTEGER PRIMARY KEY ASC," +
      "ADRES text" +
   
      ")");
      tx.executeSql(
        "CREATE TABLE IF NOT EXISTS NL_MalKabul " +
        "(" +
        "ID INTEGER PRIMARY KEY ASC," +
        "FIRMA_DOVTUT number," +
        "FISNO text,"+
        "INCKEYNO double,"+
        "STHAR_ACIKLAMA text,"+
        "STHAR_BF double,"+
        "STHAR_GCKOD text,"+
        "STHAR_GCMIK double,"+
        "STHAR_IAF double,"+
        "STHAR_NF double,"+
        "STHAR_TARIH text,"+
        "STOK_ADI text,"+
        "STOK_KODU text,"+
        "CARI_ADI text"+
        ")");
 
      tx.executeSql(
        "CREATE TABLE IF NOT EXISTS App_User" +
        "(" +
        "ID INTEGER PRIMARY KEY ASC," +
        "Sifre double," +
        "Name text" +
    
        ")");
        tx.executeSql(
          "CREATE TABLE IF NOT EXISTS NL_ProgramAyarlari" +
          "("+
          "ID INTEGER PRIMARY KEY ASC,"+
          "YaziciAdi string"+
        
          ")");

        tx.executeSql(
          "CREATE TABLE IF NOT EXISTS M_REMEMBER_ACC" +
          "("+
          "ID INTEGER PRIMARY KEY ASC,"+
          "Sifre text,"+
          "Name text"+
          ")");

        
      }




}



// WEBPACK FOOTER //
// ./src/providers/dal/dal.ts